import configHelper from '@/config/ConfigHelper'
import { i18n } from '@/i18n'

function GenerateTiposWebhookNotification () {
  return [
    { 
      label: i18n.t('tipos.webhook_notification.teams_workflow.label'), 
      value: 'TeamsWorkflow',
      description: i18n.t('tipos.webhook_notification.teams_workflow.description') 
    },
    {
      label: i18n.t('tipos.webhook_notification.zerocoma.label'), 
      value: 'Zerocoma',
      description: i18n.t('tipos.webhook_notification.zerocoma.description')
    },
  ]
}

function GenerateTiposWebhookEvent () {
  return [
    {
      label: i18n.t('tipos.webhook_event.change_state.label'),
      value: 'change_state',
      description: i18n.t('tipos.webhook_event.change_state.description')
    },
    {
      label: i18n.t('tipos.webhook_event.change_state_received.label'),
      value: 'change_state_received',
      description: i18n.t('tipos.webhook_event.change_state_received.description')
    },
    {
      label: i18n.t('tipos.webhook_event.new_invoice_received.label'),
      value: 'new_invoice_received',
      description: i18n.t('tipos.webhook_event.new_invoice_received.description')
    },
    {
      label: i18n.t('tipos.webhook_event.verifactu_emitted_response.label'),
      value: 'verifactu_emitted_response',
      description: i18n.t('tipos.webhook_event.verifactu_emitted_response.description')
    },
    {
      label: i18n.t('tipos.webhook_event.verifactu_fault_response.label'),
      value: 'verifactu_fault_response',
      description: i18n.t('tipos.webhook_event.verifactu_fault_response.description')
    }
  ]
}


function GenerateTiposWebhookAuth () {
  return [
    {
      label: i18n.t('tipos.webhook_auth.none.label'),
      value: 'None',
      description: i18n.t('tipos.webhook_auth.none.description')
    },
    {
      label: i18n.t('tipos.webhook_auth.static_token.label'),
      value: 'StaticToken',
      description: i18n.t('tipos.webhook_auth.static_token.description')
    },
    // {
    //   label: i18n.t('tipos.webhook_auth.user_password.label'),
    //   value: 'UserPassword',
    //   description: i18n.t('tipos.webhook_auth.user_password.description')
    // }
  ]
}

function TIPOS_WEBHOOK_NOTIFICATION (state) {
  return configHelper.getConfig(state, 'TIPOS_WEBHOOK_NOTIFICATION', GenerateTiposWebhookNotification)
}

function TIPOS_WEBHOOK_EVENT (state) {
  return configHelper.getConfig(state, 'TIPOS_WEBHOOK_EVENT', GenerateTiposWebhookEvent)
}

function TIPOS_WEBHOOK_AUTH (state) {
  return configHelper.getConfig(state, 'TIPOS_WEBHOOK_AUTH', GenerateTiposWebhookAuth)
}

export {
  TIPOS_WEBHOOK_NOTIFICATION,
  TIPOS_WEBHOOK_EVENT,
  TIPOS_WEBHOOK_AUTH
}

